import {
	ConfirmationModal,
	Button,
} from '@webmotors/storybook.pf';

import { HEADER_STRINGS } from '../../../../utils/header.constants';

import type { TBlockConfirmationModalConfig } from './block-confirmation-modal.types';

const BlockConfirmationModal = ({
	isOpen,
	isBlocked,
	isLoading,
	onOpenChange,
	onConfirm,
	onCancel,
}: TBlockConfirmationModalConfig) => {
	const confirmLabel = isBlocked ? HEADER_STRINGS.CONFIRM : HEADER_STRINGS.CONFIRM_BLOCK;

	return (
		<ConfirmationModal
			open={isOpen}
			onOpenChange={onOpenChange}
			title={
				isBlocked
					? HEADER_STRINGS.UNBLOCK_MODAL_TITLE
					: HEADER_STRINGS.BLOCK_MODAL_TITLE
			}
		>
			<ConfirmationModal.Content>
				<p>
					{isBlocked
						? HEADER_STRINGS.UNBLOCK_MODAL_CONTENT
						: HEADER_STRINGS.BLOCK_MODAL_CONTENT}
				</p>
			</ConfirmationModal.Content>
			<ConfirmationModal.Actions>
				<Button
					variant="modal-secondary"
					onClick={onCancel}
					data-testid="cancel-block-button"
					data-qa="cancel-block-button"
					disabled={isLoading}
				>
					{HEADER_STRINGS.CANCEL}
				</Button>
				<Button
					variant="modal-primary"
					onClick={onConfirm}
					data-testid="confirm-block-button"
					data-qa="confirm-block-button"
					disabled={isLoading}
				>
					{isLoading ? HEADER_STRINGS.LOADING : confirmLabel}
				</Button>
			</ConfirmationModal.Actions>
		</ConfirmationModal>
	);
};

BlockConfirmationModal.displayName = 'BlockConfirmationModal';
export { BlockConfirmationModal };
